var map = {
	"./coin-fly1.png": 303173,
	"./coin-fly2.png": 431374,
	"./flash.png": 631367,
	"./freeplay.png": 675105,
	"./halo.png": 87443,
	"./light.png": 647117,
	"./main.png": 651934,
	"./num-bg.png": 494125,
	"./rainbow.png": 350659,
	"./star-fly.png": 207481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 280540;